var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94177 8.97169C6.9048 9.06145 6.81696 9.12 6.72 9.12H6.24H5.76H5.28C5.18304 9.12 5.0952 9.06143 5.05823 8.97169C5.02127 8.88192 5.04192 8.77873 5.11055 8.71008L5.51998 8.30065V5.61935L5.11055 5.20943C5.0419 5.14078 5.02127 5.03759 5.05823 4.94782C5.0952 4.85805 5.18304 4.79998 5.28 4.79998H5.76H6H6.24C6.37247 4.79998 6.48 4.90702 6.48 5.03998V8.30063L6.88992 8.71005C6.95808 8.77873 6.97873 8.88192 6.94177 8.97169ZM6 2.88C6.39696 2.88 6.72 3.20257 6.72 3.6C6.72 3.99696 6.39696 4.32 6 4.32C5.60304 4.32 5.28 3.99696 5.28 3.6C5.28 3.20257 5.60304 2.88 6 2.88ZM6 0C2.69184 0 0 2.69135 0 6C0 9.30816 2.69184 12 6 12C9.30865 12 12 9.30816 12 6C12 2.69135 9.30865 0 6 0Z",
    fill: "#F0F8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.01ddb916bd5a49c48f7acc9cdf6dabd2.svg";
export { ForwardRef as ReactComponent };